import {Injectable} from '@angular/core';

declare var $: any;

@Injectable()
export class NotificationService {

  constructor() {
  }

  smallBox(data, cb?) {
    $.smallBox(data, cb)
  }

  bigBox(data, cb?) {
    $.bigBox(data, cb)
  }

  smartMessageBox(data, cb?) {
    $.SmartMessageBox(data, cb)
  }

  confirmDialogYesNo2(title: string, message: string, cb?){
    $.SmartMessageBox({
      title: title,
      content: message,
      buttons: '[No][Si]'
    }, (ButtonPressed) => {
      if (ButtonPressed === "Si") {
        cb();        
      }
      if (ButtonPressed === "No") {        
      }
    });
  }

  async confirmDialogYesNo(title: string, message: string, messageSuccess: string, cb?){
    $.SmartMessageBox({
      title: title,
      content: message,
      buttons: '[No][Si]'
    }, (ButtonPressed) => {
      if (ButtonPressed === "Si") {
        try{
          cb().then(dat => {
            this.alertOK(messageSuccess, undefined);
          }).catch(error => {
            console.error(error);
            this.alertError(error, undefined);  
          });          
        }catch(error){
          console.error(error);
          this.alertError(error, "Error en CallBack");
        }                
      }
      if (ButtonPressed === "No") {        
      }
    });
  }

  alertOK(message: string, title: string = undefined){
    $.smallBox({
      title: title || "Transacción satisfactoria!!!...",
      content: "<i class='fa fa-clock-o'></i> <i>"+message+"</i>",
      color: "#659265",
      iconSmall: "fa fa-check fa-2x fadeInRight animated",
      timeout: 4000
    });
  }

  alertNewOrder(message, order){
    $.bigBox({
      title: message.notification.title,
      content: message.notification.body,
      color: "#3276B1",
      //timeout: 8000,
      icon: "fa fa-bell swing animated",
      number: 'Orden #' + message.data.number
    });
  }


  bigAlertNewOrder(message, order){
    $.bigBox({
      title: message.notification.title,
      content: message.notification.body,
      color: "#ff0000",
      sound_file: 'timbre',
      //timeout: 8000,
      icon: "fa fa-bell swing animated",
      number: 'Orden #' + message.data.number
    });
  }
  

  alertBox(title:string, content:string, color:string, number:string){
    $.bigBox({
      title,
      content,
      color,
      //timeout: 8000,
      icon: "fa fa-bell swing animated",
      number
    });
  }

  alertError(error: any, title: string = undefined){
    $.smallBox({
      title: title || "Error!!!...",
      content: "<i class='fa fa-clock-o'></i> <i>Error en solicitud: "+JSON.stringify(error) || error+"</i>",
      color: "#C46A69",
      iconSmall: "fa fa-times fa-2x fadeInRight animated",
      timeout: 4000
    });
  }

}
